module.exports = __webpack_public_path__ + "static/media/door.76dcfbb8.svg";